import './BiographyCard.css';
import { useEffect } from "react";

interface BiographyCardProps {
    imgUrl: string;
    desc: string;
}

const BiographyCard: React.FC<BiographyCardProps> = ({ imgUrl, desc }) => {
    useEffect(() => {
        const img = new Image();
        img.src = imgUrl;
    }, [imgUrl]);

    return (
        <div className="biography_cardWrap">
            <div className="biography_card">
                <div className="biography_cardDepth">
                    <figure className="biography_cardFigure">
                        <img
                            src={imgUrl}
                            alt='Медитация'
                        />
                    </figure>
                </div>
                
                <div className="biography_cardContents biography_cardBack">
                    <div className="biography_cardDepth">
                        <div className="retro">
                            <div className='desc'>
                                <p>
                                    {desc}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default BiographyCard;